import * as React from 'react';

export type DMStyleProps = React.StyleHTMLAttributes<HTMLStyleElement>;

export const DMStyle = ({ children, ...props }: DMStyleProps) => {
  return <style {...props}>{children}</style>;
};
DMStyle.displayName = 'DMStyle';
